import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import chatIcon from "../../assets/images/chatIcon.png";
import date from "../../assets/images/calendar.svg";
import mail from "../../assets/images/mail.png";
import mailMobile from "../../assets/images/mail.svg";
import fileMobile from "../../assets/images/fileMobile.png";
import dateMobile from "../../assets/images/date-blue-icon.png";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import { useDispatch, useSelector } from "react-redux";
import ContantPopupForm from "../../components/ContactPopupForn/ContantPopupForm";
import ServiceCenter from "../../components/ServiceCenter/ServiceCenter";
import { GetAmitimBranches } from "../../services/GetAmitimBranches";
import {
    getGoogleMapsLink,
    getWazeLink,
} from "../../utils/helpers/contactUtil";
import CircleLoading from "../../components/CircleLoading/CircleLoading"
import "./Contact.scss";
import {
    setAudienceReception, setAudienceReceptionArabic, setEmail, setFaxNumber,
    setPhoneAbroad, setPhoneNumber, setServiceHoursCenterServices,
    setServiceHoursCenterServicesArabic, setServiceHoursPhone, setServiceHoursPhoneArabic,
    setSmsLink, SET_AUDIENCE_RECEPTION, SET_AUDIENCE_RECEPTION_ARABIC, SET_EMAIL, SET_FAX_NUMBER,
    SET_PHONE_ABROAD, SET_PHONE_NUMBER, SET_SERVICE_HOURS_CENTER_SERVICES,
    SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC, SET_SERVICE_HOURS_PHONE,
    SET_SERVICE_HOURS_PHONE_ARABIC, SET_SMS_LINK
} from "../../state/actions/AmitimContactActions";
import { Divider } from '@mui/material';
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { screenSzie } from "../../utils/main";

const serviceUrl = "https://www.amitim.com/שירות-לקוחות/זימון-תורים";

const Contact = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation("common");
    const [branches, setBranches] = useState([]);
    const [generalBranches, setGeneralBranches] = useState<any>({});
    const { phoneNumber, phoneAbroad, smsLink, serviceHoursPhoneArabic, serviceHoursPhone,
        audienceReception, audienceReceptionArabic, email, faxNumber,
        serviceHoursCenterServices, serviceHoursCenterServicesArabic } = useSelector((state: any) => state.ContactReducer);
    const [loading, setLoading] = useState<boolean>(false);
    const { width } = useWindowDimensions();
    const isSmallPhone = (width<= screenSzie.smallPhone); 

    const openContactPopupForm = () => {
        dispatch(setModalState(true));
        dispatch(setModalChild(<ContantPopupForm size={"lg"} center={true} />));
        // dispatch(setModalChild(<ErrorPopup size="m" />))
    };

    // dont delete, it will be use in the future 
    // const openChatPopupForm = () => {

    // };


    useEffect(() => {
        document.title = "amitim " + t("contact.title");
    }, []);

    useEffect(() => {
        async function init() {

            setLoading(true)
            const { branches, generalBranches }: any = await GetAmitimBranches();
            if (branches?.length)
                await setBranches(branches);
            if (generalBranches?.length)
                await setGeneralBranches(generalBranches.at(0))

            if (!phoneNumber) {
                dispatch(setPhoneNumber(generalBranches.at(0)[SET_PHONE_NUMBER]))
                dispatch(setPhoneAbroad(generalBranches.at(0)[SET_PHONE_ABROAD]))
                dispatch(setSmsLink(generalBranches.at(0)[SET_SMS_LINK]))
                dispatch(setServiceHoursCenterServices(generalBranches.at(0)[SET_SERVICE_HOURS_CENTER_SERVICES]))
                dispatch(setServiceHoursPhoneArabic(generalBranches.at(0)[SET_SERVICE_HOURS_PHONE_ARABIC]))
                dispatch(setAudienceReception(generalBranches.at(0)[SET_AUDIENCE_RECEPTION]))
                dispatch(setAudienceReceptionArabic(generalBranches.at(0)[SET_AUDIENCE_RECEPTION_ARABIC]))
                dispatch(setEmail(generalBranches.at(0)[SET_EMAIL]))
                dispatch(setFaxNumber(generalBranches.at(0)[SET_FAX_NUMBER]))
                dispatch(setServiceHoursPhone(generalBranches.at(0)[SET_SERVICE_HOURS_PHONE]))
                dispatch(setServiceHoursCenterServicesArabic(generalBranches.at(0)[SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC]))
            }
            setLoading(false)
        }

        init();

    }, []);

    return ((
        <main id="contact-page main" className="page contact">
            <div className="mb-3"><h1> {t("contact.title")}</h1></div>

            <div className="wrap-btns"
             aria-modal="true"
             aria-labelledby="סגור חלונית">
                <button onClick={openContactPopupForm}>
                    <img className="desktop-inline-block" src={mail} alt="" />
                    <img className="mobile" src={mailMobile} alt="" />
                    <span> {t("contact.customerService")} </span>
                </button>
                {/* dont delete, it will be use in the future  */}
                {/* <button onClick={openChatPopupForm}>
                    <img className="desktop-inline-block" src={chatIcon} alt="chat-ןcon" />
                    <img className="mobile" src={chatIcon} alt="chat-ןcon" />
                    <span> {t("contact.chatBtn")} </span>
                </button> */}
            </div>

            {loading ? (<div className="wrap-details-Contact d-flex" style={{ justifyContent: "center", alignItems: "center" }}>
                <CircleLoading />
            </div>
            ) :
                <>
                    <div className="wrap-details-Contact d-flex">

                        <div className="right-details">
                            <div className="wrap-data-right">
                                <div className="right-wrap" id="right-wrap-upper">
                                    <div className="data ">
                                        <h2 id="telephoneAnswer"> {t("contact.telephoneAnswer")}</h2>
                                        <div className="telephone"><h2 className="small m-b-l-8">{t("contact.telephone")}</h2></div>
                                        <div className="value">{phoneNumber}</div>
                                    </div>
                                    <div className="data abrod">
                                        <div><h2 className="small m-b-l-8">{t("contact.abroadTelephone")}</h2></div>
                                        <div className="value black">
                                            {phoneAbroad}
                                        </div>
                                    </div>
                                </div>
                                <div className="right-wrap">
                                    <h2> {t("contact.smsServiceTitle")}</h2>
                                    <div className="data">
                                        <div className="small">{t("contact.smsService")}</div>
                                        <div className="value black">{generalBranches?.smsLink}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="data-center data center">
                                <div><h2 className="activity-hours" >{t("contact.activityTime")}</h2></div>
                                <div className="value black">
                                    {i18n.language === "he"
                                        ? serviceHoursPhone
                                        : serviceHoursPhoneArabic}
                                </div>
                            </div>
                        </div>
                        <div className="left-details">
                            <h2> {t("contact.moreDetails")}</h2>
                            <div className="wrap-details-info">
                                <div className="data">
                                    <div><h3 className="small">{t("contact.mail")}</h3></div>
                                    <div className="value">
                                        <a
                                            href={`mailto:${email}`}
                                            style={{
                                                cursor: "pointer",
                                                color: "inherit",
                                                textDecoration: "underline" ,
                                            }}
                                        >
                                            {email}
                                        </a>
                                    </div>
                                </div>
                                <div className="data">
                                    <div> <h3 className="small" style={{ display: faxNumber != " " ? "block" : "none" }}>{t("contact.fax")}</h3></div>
                                    <div className="value black">{faxNumber}</div>
                                </div>
                                <div className="data">
                                    <div><h3 className="small">{t("contact.address")}</h3></div>
                                    <div className="value black">
                                        {i18n.language === "he"
                                            ? audienceReception
                                            : audienceReceptionArabic}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
            {loading ? (<div className="wrap-details-Contact d-flex" style={{ justifyContent: "center", alignItems: "center" }}>
                <CircleLoading />
            </div>
            ) :
                <div className="wrap-details-Contact">
                    <h2 style={{ marginBottom: "24px" }}> {t("contact.serviceCenter")}</h2>
                    <button style={{width: `${isSmallPhone? "262px":"300px"}` ,marginRight: `${isSmallPhone? "-10px":"0px"}` }} className="green" onClick={() => window.open(serviceUrl)}>
                        <img className="desktop-inline-block" src={date} alt="date-icon" />
                       { isSmallPhone? null:<img
                            className="mobile-inline-block"
                            src={dateMobile}
                            alt="date-icon"
                        />}
                        {t("contact.queueSummons")}
                    </button>
                    <div className="service-center">



                        {branches?.map((service: any) => {
                            return (
                                <ServiceCenter
                                    key={service.id}
                                    city={service.city}
                                    detail={service.address}
                                    googleLink={getGoogleMapsLink(service.city)}
                                    wazeLink={getWazeLink(service.city)}
                                />
                            );
                        })}
                    </div>
                    <div className="small" id="activityServiceCenter"><h4>{t("contact.activityServiceCenter")}</h4></div>
                    <div className="value f-21 desktop">
                        {i18n.language === "he"
                            ? generalBranches?.serviceHoursCenterServices
                            : generalBranches?.serviceHoursCenterServicesArabic}
                    </div>
                    <div className="value f-21 mobile" id="activity-hours-id">
                        {i18n.language === "he"
                            ? generalBranches?.serviceHoursCenterServices
                            : generalBranches?.serviceHoursCenterServicesArabic}
                        {/* {t("contact.activityServiceDetails1")}
          <div>{t("contact.activityServiceDetails2")}</div> */}
                    </div>
                </div>
            }
        </main>
    )
    )
}

export default Contact;
